import styled from 'styled-components';
import photo from 'assets/images/photo-4.jpg';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #010101;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
`;

export const PhotoWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const Photo = styled.img.attrs({ src: photo })`
  width: auto;
  height: 100%;
  object-fit: contain;
`;

export const Credit = styled.article`
  width: 134px;
  font-size: 12px;
  line-height: 17px;
  position: absolute;
  bottom: 72px;
  right: -160px;
`;

export const Video = styled.div`
  height: 100%;
  position: relative;
  display: block;

  video {
    width: auto;
    height: 100%;
    object-fit: contain;
  }
`;
